import * as axios from 'axios';

const endpoints = {
    PROJECT_GET: 'project',
    PLAYSETS: 'playsets',
    PROJECT_DESIGN: 'project_design',
    ADD_PROJECT_DESIGN: 'add_project_design'
};

export default class ApiService {

    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    getProject(projectId) {
        return axios.get(this.baseUrl + endpoints.PROJECT_GET + `/${projectId}`)
            .then(response => response.data);
    }

    getPlaysets(projectId) {
        return axios.get(this.baseUrl + endpoints.PLAYSETS + `/${projectId}`)
            .then(response => response.data);
    }

    addProjectDesign(projectDesign) {
        return axios.post(this.baseUrl + endpoints.ADD_PROJECT_DESIGN, projectDesign)
            .then(response => response.data);
    }

}


// WEBPACK FOOTER //
// ./assets/vue/apps/participate/api-service.js